<template>
  <div class="content">
    <controlbar @input-event="setCorporation" @focusin="allCheckDelete">
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox"></th>
          <td class="table_contents">
            <label class="corporation_name_label">
              {{ corporationNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="contract_date_label">
              {{ contractDateLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="available_device_counts_label">
              {{ availableDeviceCountsLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="company_id_label">
              {{ companyIdLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="company_name_label">
              {{ companyNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="use_location_label">
              {{ useLocationLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="password_enable_label">
              {{ passwordEnableLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="auto_logout_enable_label">
              {{ autoLogoutEnableLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="rating_quarity_enable_label">
              {{ ratingQuarityEnableLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="push_notification_enable_label">
              {{ pushNotificationEnableLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispCorporation in corporations"
            :key="dispCorporation.companyId"
          >
            <th class="table_checkbox"></th>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label class="corporation_name">
                {{ dispCorporation.corporationName }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label class="contract_date">
                {{ dispCorporation.contractDate }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label class="available_device_counts">
                {{ dispCorporation.usedDeviceCount }}/{{
                  dispCorporation.availableDeviceCounts
                }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label class="company_id">
                {{ dispCorporation.companyId }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label class="company_name">
                {{ dispCorporation.companyName }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label v-if="dispCorporation.locationInfoEnableFlag" class="">
                {{ beaconLabel }}
              </label>
              <label
                v-else-if="dispCorporation.gpsEnableFlag"
                class="use_location"
              >
                {{ GPSLabel }}
              </label>
              <label v-else class="use_location">
                {{ offLabel }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label
                v-if="dispCorporation.passwordEnableFlag"
                class="password_enable"
              >
                {{ onLabel }}
              </label>
              <label v-else class="password_enable">
                {{ offLabel }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label
                v-if="dispCorporation.autoLogoutEnableFlag"
                class="auto_logout_enable"
              >
                {{ onLabel }}
              </label>
              <label v-else class="auto_logout_enable">
                {{ offLabel }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label
                v-if="dispCorporation.ratingQuarityEnableFlag"
                class="rating_quarity_enable"
              >
                {{ onLabel }}
              </label>
              <label v-else class="rating_quarity_enable">
                {{ offLabel }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCorporation)">
              <label
                v-if="dispCorporation.pushNotificationEnableFlag"
                class="push_notification_enable"
              >
                {{ onLabel }}
              </label>
              <label v-else class="push_notification_enable">
                {{ offLabel }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setCorporation(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFailureModal">
      <failureModalWindow :question="failureWord" @close="close">
      </failureModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import Pagination from 'vue-pagination-2'
import failureModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      corporationNameLabel: '法人名',
      contractDateLabel: '契約日',
      availableDeviceCountsLabel: '使用台数/契約台数',
      companyIdLabel: 'テナントID',
      companyNameLabel: 'テナント名',
      useLocationLabel: '位置情報',
      passwordEnableLabel: 'パスワード利用',
      autoLogoutEnableLabel: '自動ログアウト',
      ratingQuarityEnableLabel: '評価機能',
      pushNotificationEnableLabel: 'プッシュ通知',
      beaconLabel: 'ビーコン',
      GPSLabel: 'GPS',
      onLabel: 'ON',
      offLabel: 'OFF',
      dispCorporations: [],
      windowHeight: '',
      showFailureModal: false,
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0
    }
  },
  computed: {
    corporations() {
      return this.$store.state.corporations.corporations
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.corporations.total
      ) {
        return this.$store.state.corporations.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.corporations.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.corporations.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.state.prevSearchWord = ''
    this.setCorporation(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    Pagination,
    failureModalWindow,
    loadingModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.dispCorporations.length; i++) {
        this.dispCorporations[i].checked = this.checked
      }
    },
    close(e) {
      this.showFailureModal = false
    },
    createCorporationsList(e) {
      // 表示するリストをページネーションから受け取る。
      this.dispCorporations = e
      this.checked = false
    },
    async setCorporation(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('systemAdminDefine/clearCompanyInfo')
        await this.$store.dispatch('corporations/setCorporations', {
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevSearchWord = searchWord
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_140001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0045')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    allCheckDelete(e) {
      for (let i = 0; i < this.dispCorporations.length; i++) {
        this.dispCorporations[i].checked = false
      }
      this.checked = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('systemAdminDefine/setCompanyInfo', payload)
        await this.$store.dispatch(
          'corporations/setDetailCorporation',
          payload.companyId
        )
        await this.$store.dispatch(
          'corporations/setCallAppDefine',
          payload.companyId
        )
        this.$router.push('/master/corporations/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_140001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0046')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped>
.content,
.bottom {
  width: calc(100% - 262px);
}
.table_contents {
  width: 10%;
}
.table_contents:nth-child(7),
.table_contents:nth-child(10) {
  width: 7%;
}
.table_contents:nth-child(4) {
  width: auto;
}
.content_title {
  background-color: #ddffff;
}
.bottom {
  background-color: #bbffff;
}
.active .router {
  background-color: #a7f1ff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationsList.vue